/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteShiftTemplate} from '../api'

export const useMutationDeleteShiftTemplate = createReactQueryMutationHook('deleteShiftTemplate', deleteShiftTemplate)
